import React, { Component } from "react";
import _ from "lodash";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import TimeStamp from "react-timestamp";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    PopupHeader: "Trial reminder",
    PopupText1: "Hi, ",
    PopupText2_1:
      "A friendly reminder that your Intelligent Access Management System (IAMS) trial run will ",
    PopupText2_2: "end",
    PopupText2_3: " on ",
    PopupText2_4: ".",
    PopupWebOnlyNote:
      "This only affects access to the web dashboard — you can continue using the eGeeTouch mobile app as usual after your trial ends.",
    PopupText3:
      "To continue using our system after your trial ends, please upgrade to a paid plan through the Subscription tab in Account Management page:",
    PopupText4_1:
      "If you have any questions or need help regarding this process, please contact us at ",
    PopupText4_2: "support@egeetouch.com",
    PopupText4_3: ".",
    PopupButton: "Account Management",
    PopupConfirmBtn: "I understand",
  },
  ja: {
    PopupHeader: "お知らせ",
    PopupText1: " 様",
    PopupText2_1: "インテリジェントアクセス管理システムのトライアル期間は",
    PopupText2_2: "",
    PopupText2_3: "",
    PopupText2_4: "までです。",
    PopupWebOnlyNote:
      "これはWebダッシュボードへのアクセスにのみ適用されます。トライアル終了後もeGeeTouchモバイルアプリは引き続きご利用いただけます。",
    PopupText3:
      "トライアル終了後もシステムをご利用いただくには、アカウント管理画面から有料プランへのアップグレードをお願いいたします。",
    PopupText4_1: "ご不明な点は、",
    PopupText4_2: "support@egeetouch.com",
    PopupText4_3: "へお問合せ下さい。",
    PopupButton: "支払手続へ",
    PopupConfirmBtn: "OK",
  },
  es: {
    PopupHeader: "Recordatorio de Prueba",
    PopupText1: "Hola, ",
    PopupText2_1:
      "Un recordatorio amistoso de que tu periodo de prueba del Sistema de Gestión de Acceso Inteligente (IAMS) ",
    PopupText2_2: "terminará",
    PopupText2_3: " el ",
    PopupText2_4: ".",
    PopupWebOnlyNote:
      "Esto solo afecta el acceso al panel web — puedes seguir utilizando la aplicación móvil de eGeeTouch con normalidad después de que finalice tu prueba.",
    PopupText3:
      "Para continuar utilizando nuestro sistema después de que finalice tu prueba, por favor actualiza a un plan de pago a través de la pestaña de Suscripción en la página de Gestión de Cuentas:",
    PopupText4_1:
      "Si tienes alguna pregunta o necesitas ayuda con respecto a este proceso, por favor contáctanos en ",
    PopupText4_2: "support@egeetouch.com",
    PopupText4_3: ".",
    PopupButton: "Gestión de Cuentas",
    PopupConfirmBtn: "Entiendo",
  },
});

class TrialEndingPopup extends Component {
  constructor(props) {
    super(props);

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupCloseBtn = this.handlePopupCloseBtn.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      userName: "",
      trialEndTime: "",
      showPopup: false,
      currentLanguage: "en",
    };
  }

  async componentWillMount() {
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      fire
        .database()
        .ref("groupAccounts")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let userDetails = snapshot.val();

            this.setState({
              trialEndTime: userDetails.payment.trialEndDate,
            });

            if (userDetails.payment.specialTrialMode === true) {
              this.setState({
                showPopup: true,
              });
            } else {
              this.setState({
                showPopup: false,
              });
            }
          }
        });

      fire
        .database()
        .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let userDetails = snapshot.val();
            this.setState({
              userName: userDetails.name,
            });
          }
        });
    }
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  handlePopupCloseBtn() {
    this.setState({
      showPopup: false,
    });
  }

  handleChange(e) {
    let isChecked = e.target.checked;

    this.setState({
      checked: isChecked,
    });
  }

  dateTimeFormat(time) {
    if (!time || isNaN(Number(time))) return null;
    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time * 1000);
      var japanTimeHour = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
      }).format(time * 1000);
      var japanTimeMinute = new Intl.DateTimeFormat("ja-JP", {
        minute: "2-digit",
      }).format(time * 1000);
      return japanDate + japanTimeHour + japanTimeMinute + "分";
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time} format="full" includeDay />;
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-50w"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title
              style={{
                textAlign: "center",
                fontSize: "30px",
                marginTop: "10px",
                color: "#FF2121",
              }}
            >
              {localizationStrings.PopupHeader}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              <strong>
                {this.state.currentLanguage === "en"
                  ? localizationStrings.PopupText1 + this.state.userName
                  : this.state.userName + localizationStrings.PopupText1}
              </strong>
            </p>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText2_1}
              <strong style={{ color: "#FF2121" }}>
                {localizationStrings.PopupText2_2}
              </strong>
              {localizationStrings.PopupText2_3}
              <strong>{this.dateTimeFormat(this.state.trialEndTime)}</strong>
              {localizationStrings.PopupText2_4}
            </p>
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupWebOnlyNote}
            </p>
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{ width: "80%", borderBottom: "1px solid #DDDCDC" }}
              ></div>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "80%", textAlign: "justify" }}
            >
              {localizationStrings.PopupText3}
            </p>
            <br />
            <div style={{ display: "flex", width: "80%", margin: "auto" }}>
              <NavLink
                to="/accountManagement"
                className="nav-link"
                onClick={this.handlePopupClose}
              >
                <button
                  className="boldFont"
                  style={{
                    backgroundColor: "#59A9F3",
                    color: "white",
                    border: "none",
                    height: "40px",
                    width: "200px",
                    borderRadius: "5px",
                  }}
                >
                  <p style={{ margin: "auto", padding: "auto" }}>
                    {localizationStrings.PopupButton}
                  </p>
                </button>
              </NavLink>
            </div>
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{ width: "80%", borderBottom: "1px solid #DDDCDC" }}
              ></div>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText4_1}
              <span style={{ color: "#369AF6", textDecoration: "underline" }}>
                <a href="mailto: support@egeetouch.com">
                  {localizationStrings.PopupText4_2}
                </a>
              </span>
              {localizationStrings.PopupText4_3}
            </p>
            <br />
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "auto",
                margin: "auto",
              }}
            >
              <button
                className="boldFont"
                style={{
                  backgroundColor: "#59A9F3",
                  color: "white",
                  border: "none",
                  height: "40px",
                  width: "200px",
                  borderRadius: "5px",
                }}
                onClick={this.handlePopupCloseBtn}
              >
                <p style={{ margin: "auto", padding: "auto" }}>
                  {localizationStrings.PopupConfirmBtn}
                </p>
              </button>
            </div>
            <br />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default TrialEndingPopup;
